<template lang="pug">
.icon.custom(v-if="src" :class="iconClass")
  img.custom-icon(:src="src" alt="")
.icon.default(v-else :class="iconClass")
  component(:is="defaultSrc")
</template>

<script lang="ts">
import {type Component, defineAsyncComponent, defineComponent} from "vue";

export default defineComponent({
  name: "GammaIcon",
  props: {
    src: {
      type: String,
    },
    defaultSrc: {
      type: [String, Object] as () => string | Component,
      required: true,
    },
    iconClass: {
      type: String,
    },
  },
  setup(props) {
    function getComponent(src: string) {
      return defineAsyncComponent(() => import(/* @vite-ignore */ "./" + src));
    }

    return {
      getComponent,

    };
  },
});
</script>

<style lang="scss" scoped>
.icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .custom-icon {
    width: 100%;
    height: 100%;
  }

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
